require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./portland-area-canine-therapy-teams.json") })
        }
      }, "path---portland-area-canine-therapy-teams");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---portland-area-canine-therapy-teams!./.cache/json/portland-area-canine-therapy-teams.json
// module id = 957
// module chunks = 231608221292675